import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {RichTextSchema} from '../richText'
import {FormLayoutSchema} from './formLayout'
import {TwoColumnFormLayoutSchema} from './twoColumnFormLayout'
import {MarketoCampaignSchema} from './marketoCampaign'
import {EloquaCampaignSchema} from './eloquaCampaign'
import {safeOptional} from '../../safe-optional'

export const FormSchema = buildEntrySchemaFor('form', {
  fields: z.lazy(() =>
    z.object({
      heading: safeOptional(RichTextSchema),
      campaign: safeOptional(z.union([MarketoCampaignSchema, EloquaCampaignSchema])),
      layout: safeOptional(z.union([FormLayoutSchema, TwoColumnFormLayoutSchema])),
      layoutOption: z.union([FormLayoutSchema, TwoColumnFormLayoutSchema]),
      submitText: z.string(),
    }),
  ),
})

export type Form = z.infer<typeof FormSchema>
